import { lazy, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthGuard from '../guards/AuthGuard';
import ClientGuard from '../guards/ClientGuard';
import LoadingScreen from '../components/LoadingScreen';
import { CLIENT_DASHBOARD } from '../config';
import ClientLayout from '../layouts/vendor/dashboard';

// NOTE: Reuse vendor dashboard layout styling for client unless a separate layout is provided

const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/client/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};

// Dashboard
const Dashboard = Loadable(lazy(() => import('../pages/users/client/dashboard/Dashboard')));

// QR Logs (to be provided by user; placing placeholders for route wiring)
const QRLogs = Loadable(lazy(() => import('../pages/users/client/master/QRLogs/QRLogs')));
const QRLogOperation = Loadable(lazy(() => import('../pages/users/client/master/QRLogs/QRLogOperation')));


// QR Logs (to be provided by user; placing placeholders for route wiring)
const QRHistory = Loadable(lazy(() => import('../pages/users/client/master/QRHistory/QRLogs')));
const QRHistoryOperation = Loadable(lazy(() => import('../pages/users/client/master/QRHistory/QRLogOperation')));


// Delay Module
const DelayModule = Loadable(lazy(() => import('../pages/users/client/master/DelayModule/DelayModules')));
const DelayModuleOperation = Loadable(lazy(() => import('../pages/users/client/master/DelayModule/DelayModuleOperation')));
const DelayModuleTimingPage = Loadable(lazy(() => import('../pages/users/client/master/DelayModule/DelayModuleTimingPage')));

// Staff — reuse super-admin components with client-scoped basePath
const ClientStaff = Loadable(lazy(() => import('../pages/users/super-admin/masters/Staff/Staff')));
const ClientStaffOperation = Loadable(lazy(() => import('../pages/users/super-admin/masters/Staff/StaffOperation')));

const ClientRoutes = {
    path: '/client',
    element: (
        <AuthGuard>
            <ClientGuard>
                <ClientLayout />
            </ClientGuard>
        </AuthGuard>
    ),
    children: [
        { element: <Navigate to={CLIENT_DASHBOARD} replace />, index: true },
        { path: 'dashboard', element: <Dashboard /> },
        {
            path: 'master',
            children: [
                {
                    path: 'qr-logs',
                    children: [
                        { path: '', element: <QRLogs /> },
                        { path: 'add', element: <QRLogOperation /> },
                        { path: ':logId/edit', element: <QRLogOperation /> },
                        { path: ':logId/view', element: <QRLogOperation /> },
                    ],
                },
                {
                    path: 'qr-history',
                    children: [
                        { path: '', element: <QRHistory /> },
                        { path: 'add', element: <QRHistoryOperation /> },
                        { path: ':logId/edit', element: <QRHistoryOperation /> },
                        { path: ':logId/view', element: <QRHistoryOperation /> },
                    ],
                },
                {
                    path: 'staff',
                    children: [
                        { path: '', element: <ClientStaff basePath="/client/master/staff" dashboardPath="/client/dashboard" /> },
                        { path: 'add', element: <ClientStaffOperation basePath="/client/master/staff" dashboardPath="/client/dashboard" /> },
                        { path: ':id/edit', element: <ClientStaffOperation basePath="/client/master/staff" dashboardPath="/client/dashboard" /> },
                        { path: ':id/view', element: <ClientStaffOperation basePath="/client/master/staff" dashboardPath="/client/dashboard" /> },
                    ],
                },
            ]
        },
        
    ],
};

export default ClientRoutes;


